<template>
  <az-container>
    <az-form>
      <v-dialog value="true" persistent max-width="800" non-linear>
        <v-card>
          <v-card-title class="title primary white--text thin" primary-title>
                        <span v-if="solicitacao.situacao != 'RASCUNHO'"
                              class="thin--span">Solicitação de {{ item | tipoAnexoFornecedor }}
                        </span>
            <span v-else
                  class="thin--span">Editar Rascunho de {{ item | tipoAnexoFornecedor }}
                        </span>
            <v-btn icon @click.native="fecharModal" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-flex xs12 sm12 d-flex class="header">
            <v-layout wrap align-center>
              <v-flex v-if="solicitacao.dataCadastro" xs12 sm3 d-flex>
                <div class="az-text">
                  <label class="primary--text font-weight-bold">Data/Hora Criação</label>
                  <p>{{ solicitacao.dataCadastro | dataHumanizada }}</p>
                </div>
              </v-flex>
              <v-flex xs12 sm2 d-flex>
                <div class="az-text">
                  <label class="primary--text font-weight-bold">Nº Edital</label>
                  <p>{{ licitacao.numeroEdital }}</p>
                </div>
              </v-flex>
              <v-flex xs12 sm2 d-flex>
                <div class="az-text">
                  <label class="primary--text font-weight-bold">Situação</label>
                  <p v-if="!solicitacao.situacao">{{'Rascunho'}}</p>
                  <p v-if="solicitacao.situacao">{{ solicitacao.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao) }}</p>
                </div>
              </v-flex>
              <v-flex xs12 sm9 d-flex>
                <div class="az-text">
                  <label class="primary--text font-weight-bold">Objeto</label>
                  <p>{{ licitacao.objeto }}</p>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <p class="primary--text subtitle">Assunto {{ item | tipoAnexoFornecedor }}
            <span class="ml-1 red--text">*</span>
            <span class="ml-1 red--text"
                  v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span>
          </p>
          <v-card-text>
            <v-textarea class="textarea-resposta" placeholder="Informe o assunto..."
                        v-model="solicitacao.assunto" v-on:keyup="contarTamanhoTexto" counter/>
          </v-card-text>
          <div v-if="solicitacao.arquivoNome && solicitacao.arquivoUri && !solicitacao.anexoRemovido">
            <p class="primary--text subtitle" style="margin-top: -20px">Anexo</p>
            <v-flex xs12 sm12 d-flex class="header ml-5" style="margin-right: 56px">
              <v-layout wrap align-center>
                <span style="font-size: 12px; font-family: 'Roboto', sans-serif;">Nome</span>
                <v-spacer></v-spacer>
                <span style="font-size: 12px; font-family: 'Roboto', sans-serif;">Ações</span>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="header mb-1 mt-3">
              <div style="border-top: 1px solid #ccc;"></div>
            </v-flex>
            <v-flex xs12 sm12 d-flex class="header mx-5 mt-0">
              <v-layout wrap align-center>
                                <span style="color: black; font-size: 13px; font-family: 'Roboto', sans-serif;">
                                    {{ solicitacao.arquivoNome }}
                                </span>
                <v-spacer></v-spacer>
                <a :href="criarLinkDownload(solicitacao.arquivoUri)" target="_blank">
                  <v-icon>get_app</v-icon>
                </a>
                <a @click.prevent="removerAnexo()">
                  <v-icon>close</v-icon>
                </a>
              </v-layout>
            </v-flex>
          </div>
          <div v-else>
            <p class="primary--text subtitle" style="margin-top: -20px">Anexo</p>
            <credenciamento-esclarecimento-anexo style="margin-top: -20px" @uploadArquivo="setarArquivoUpload" @removerArquivoUpload="removerArquivoUpload" @configuracaoRepositorio="setarRepositorio"/>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div>
              <button v-if="solicitacao.assunto" class="action-primary-button"
                      @click.prevent="validarAnexoSalvar" :disabled="enviandoSolicitacao"
              >
                Salvar {{ item | tipoAnexoFornecedor }}
              </button>
              <div v-else>
                <v-tooltip top nudge-top="10" max-width="200">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" class="action-primary-button-disabled btn-disabled">
                      Salvar {{ item | tipoAnexoFornecedor }}
                    </button>
                  </template>
                  É necessário que todos os campos obrigatórios sejam preenchidos para continuar.
                </v-tooltip>
              </div>
            </div>
            <div>
              <button v-if="solicitacao.assunto" class="action-primary-button"
                      @click.prevent="validarAnexoEnviar" :disabled="enviandoSolicitacao"
              >
                Enviar {{ item | tipoAnexoFornecedor }}
              </button>
              <div v-else>
                <v-tooltip top nudge-top="10" max-width="200">
                  <template v-slot:activator="{ on }">
                    <button v-on="on" class="action-primary-button-disabled btn-disabled">
                      Enviar {{ item | tipoAnexoFornecedor }}
                    </button>
                  </template>
                  É necessário que todos os campos obrigatórios sejam preenchidos para continuar.
                </v-tooltip>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </az-form>
    <modal-confirmar-etapa-anexo
        v-model="exibirConfirmacaoAnexoSalvar"
        :title="'Solicitação ' + this.tipoAnexoFornecedor(item)"
        text="Atenção, nenhum anexo foi"
        secondText="inserido, deseja continuar?"
        @fecharModalConfirm="exibirConfirmacaoAnexoSalvar = false"
        @cancelarAcao="exibirConfirmacaoAnexoSalvar = false"
        @confirmarAcao="salvarSolicitacao(); exibirConfirmacaoAnexoSalvar = false;"
    />
    <modal-confirmar-etapa-anexo
        v-model="exibirConfirmacaoAnexoEnviar"
        :title="'Solicitação ' + this.tipoAnexoFornecedor(item)"
        text="Atenção, nenhum anexo foi"
        secondText="inserido, deseja continuar?"
        @fecharModalConfirm="exibirConfirmacaoAnexoEnviar = false"
        @cancelarAcao="exibirConfirmacaoAnexoEnviar = false"
        @confirmarAcao="enviarSolicitacao(); exibirConfirmacaoAnexoEnviar = false;"
    />
  </az-container>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import {actionTypes, tiposAnexoFornecedor, tiposSituacaoEsclarecimentoImpugnacao} from "@/commons/constants";
import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo'
import CampoApresentacao from "@/commons/components/campos/campo-apresentacao.vue";
import CredenciamentoEsclarecimentoAnexo from '@/views/credenciamento/detalhe-credenciamento/commons/CredenciamentoEsclarecimentoAnexo.vue';

export default {
  name: 'CredenciamentoFornecedorEsclarecimentoSolicitacao',
  components: {CampoApresentacao, CredenciamentoEsclarecimentoAnexo, ModalConfirmarEtapaAnexo},
  props: {
    item: {
      type: String,
      default: () => {
      }
    },
    solicitacao: {
      type: Object,
      default: ()=>{}
    },
  },
  data() {
    return {
      solicitacaoEditavel: {},
      maxTextArea: 1000,
      totalRemainCount: 1000,
      limiteTextoAtingido: false,
      exibirConfirmacaoAnexoSalvar: false,
      exibirConfirmacaoAnexoEnviar: false,
      enviandoSolicitacao: false,
      anexoRemovido: false,
      anexoVazio: false,
      hadAnexoInicial: false,
      tiposSituacaoEsclarecimentoImpugnacao
    }
  },
  computed: {
    ...mapState(['licitacao'])
  },
  mounted() {
    this.setarConfiguracaoAnexo()
  },
  methods: {
    setarConfiguracaoAnexo(){
      this.solicitacao.anexoUpload = null
      this.solicitacao.anexoRemovido = false
    },
    validarAnexoSalvar() {
      if (!this.solicitacao.arquivoUri && !this.solicitacao.anexoUpload)
        this.exibirConfirmacaoAnexoSalvar = true;
      else
        this.salvarSolicitacao()
    },
    validarAnexoEnviar() {
      if (!this.solicitacao.arquivoUri && !this.solicitacao.anexoUpload)
        this.exibirConfirmacaoAnexoEnviar = true;
      else
        this.enviarSolicitacao()
    },
    contarTamanhoTexto() {
      this.totalRemainCount = this.maxTextArea - this.solicitacao.assunto.length;

      this.limiteTextoAtingido = this.totalRemainCount < 0;
      if (this.limiteTextoAtingido) this.solicitacao.assunto = this.solicitacao.assunto.slice(0, this.totalRemainCount)
    },
    async salvarSolicitacao() {
      if (this.solicitacao.id) {
        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Editando solicitação...')

        await this.editarEsclarecimentoImpugnacao(this.solicitacao)
        this.$emit('solicitacaoEditada')

        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
      } else {
        this.solicitacao.usuario.id = this.loki.user.id
        this.solicitacao.tipo = this.item
        this.solicitacao.licitacao.id = this.licitacao.id
        this.solicitacao.situacao = 'RASCUNHO'

        if(this.solicitacao.assunto.length > 1000){
          this.mostrarNotificacaoErro("O assunto não deve ultrapassar o limite de 1000 caracteres!")
          return
        }

        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Enviando solicitação...')

        await this.inserirEsclarecimentoImpugnacao({
          licitacaoId: this.licitacao.id,
          solicitacao: this.solicitacao
        })
        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
        this.$emit('solicitacaoSalva')
        this.resetarSolicitacao()
      }
    },
    async enviarSolicitacao() {
      if (this.solicitacao.id) {
        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Enviando solicitação...')

        await this.editarEsclarecimentoImpugnacao(this.solicitacao)
        await this.enviarEsclarecimentoImpugnacao(this.solicitacao.id)
        this.$emit('solicitacaoEnviada')

        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
      } else {
        this.solicitacao.usuario.id = this.loki.user.id
        this.solicitacao.tipo = this.item
        this.solicitacao.licitacao.id = this.licitacao.id
        this.solicitacao.situacao = 'AGUARDANDO'

        this.habilitarLoadingGlobal()
        this.setMensagemLoading('Enviando solicitação...')

        await this.inserirEsclarecimentoImpugnacao({
          licitacaoId: this.licitacao.id,
          solicitacao: this.solicitacao
        })
        this.desabilitarLoadingGlobal()
        this.mostrarNotificacaoSucessoDefault()
        this.$emit('solicitacaoSalva')
        this.resetarSolicitacao()
      }
    },
    tipoAnexoFornecedor(tipoAnexoChave) {
      const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
      return tipoSelecionado ? tipoSelecionado.label : ''
    },
    async removerAnexo() {
        this.solicitacao.arquivoNome = ''
        this.solicitacao.arquivoUri = ''
        this.solicitacao.anexoRemovido = true
    },
    resetarSolicitacao() {
      this.solicitacao.assunto = ''
      this.solicitacao.arquivoNome = ''
      this.solicitacao.arquivoUri = ''
      this.solicitacao.anexoRemovido = false
      this.solicitacao.anexoUpload = null
    },
    fecharModal() {
      if (this.solicitacao.id) {
        this.$emit('solicitacaoEditada')
      }
      this.resetarSolicitacao()
      this.$emit('fecharDetalhe')
    },
    setarArquivoUpload(arquivoUpload){
      this.solicitacao.anexoUpload = arquivoUpload
    },
    removerArquivoUpload(){
      this.solicitacao.anexoUpload = null
    },
    setarRepositorio(repositorioUri){
      this.solicitacao.repositorioUri = repositorioUri
    },
    ...mapActions([actionTypes.INSERIR_ESCLARECIMENTO_IMPUGNACAO, actionTypes.EDITAR_ESCLARECIMENTO_IMPUGNACAO,
      actionTypes.ENVIAR_ESCLARECIMENTO_IMPUGNACAO])
  },
  filters: {
    tipoAnexoFornecedor(tipoAnexoChave) {
      const tipoSelecionado = tiposAnexoFornecedor.find(tipoObj => tipoObj.chave === tipoAnexoChave)
      return tipoSelecionado ? tipoSelecionado.label : ''
    }
  }
}
</script>

<style lang="stylus">

    .thin
        height: 55px
        justify-content: space-between;
        align-content: center;

    .header
        margin: 10px 20px;
        color: #777777 !important

    .content
        font-size: 16px;
        margin: 0 10px;
        color: #777777 !important

    .subtitle
        font-size: 16px;
        font-weight: bold;
        margin: 0 20px;
        border-bottom: 0 solid #ccc;

    .fileDownload
        font-size: 13px;
        margin: 10px 20px;
        border-bottom: 1px solid #1145ff;
        color: #1145ff;

</style>